<template>
  <div>
    <breadcrumbs home="Products">
      <search v-model="filters.search" placeholder="Search products"/>
    </breadcrumbs>

    <v-container fluid class="pb-0 pt-2">
      <v-row dense>
        <v-col cols="12" sm="4" md="3" lg="2" class="pt-2">
          <date-picker label="As of" v-model="filters.asof" date-only @change="refresh()"/>
        </v-col>
        <v-col align="right">
          <print-list :table="this.$refs.table" title="Products" pageSize="portrait"/>
          <export-list :columns="defaultColumns" :headers="headers" :list="filteredList" fileName="products.csv" :table="this.$refs.table"/>
        </v-col>
      </v-row>
    </v-container>

    <v-data-table ref="table" class="purtrak-table"
       v-bind="listProps" :page.sync="page" :items-per-page.sync="pageSize" item-key="productId"
        :itemClass="item => item.productId === this.selectedId ? 'selected-list-item' : ''"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        :show-expand="!$vuetify.breakpoint.mobile" single-expand
        @item-expanded="({item}) => selectedId = item.productId"
        @click:row="product => selectedId = product.productId"
        @dblclick:row="(e,info) => $router.push({name:'InventoryProductsTransactions',params:{productId:info.item.productId}})">
      <template v-slot:item.details.bottles="{value}">
        {{value | number(0)}}
      </template>
      <template v-slot:item.details.cases="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:item.details.pallets="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr class="total-row">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='details.bottles'">
              {{listTotals.bottles | number(0)}}
            </td>
            <td class="text-right" v-else-if="header.value==='details.cases'">
              {{listTotals.cases | number(1)}}
            </td>
            <td class="text-right" v-else-if="header.value==='details.pallets'">
              {{listTotals.pallets | number(1)}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <v-card class="my-4 blue-grey lighten-5">
            <v-simple-table dense class="my-2 pl-12 blue-grey lighten-5" style="width:60%">
              <thead>
                <tr>
                  <th class="blue-grey lighten-5" width="25%">Lot</th>
                  <th class="py-0 text-right blue-grey lighten-5" width="25%">Bottles</th>
                  <th class="py-0 text-right blue-grey lighten-5" width="25%">Cases</th>
                  <th class="py-0 text-right blue-grey lighten-5" width="25%">Pallets</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="lot of item.details.lots" :key="lot.lot">
                  <td>{{lot.lot}}</td>
                  <td class="text-right">{{lot.bottles | number(0)}}</td>
                  <td class="text-right">{{lot.cases | number(1)}}</td>
                  <td class="text-right">{{lot.pallets | number(1)}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </td>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import commonList from '@/mixins/commonList'
import {format} from 'date-fns'

export default {
  name: 'Products',
  mixins: [commonList],
  data() {
    return {
      objectType: 'products',
      _name: 'products',
      filters: {
        search: '',
        asof: ''
      },
      today: format(new Date(), 'yyyy-MM-dd'),
      products: [],
      listTotals: {
        bottles: 0,
        cases: 0,
        pallets: 0,
      },
      columns: [],
      defaultColumns: [{ value: 'details.name', visible:true},
                       { value: 'details.bottles', visible:true},
                       { value: 'details.cases', visible:true},
                       { value: 'details.pallets', visible:true}],
      headers: [{ text: 'PRODUCT', value: 'details.name', width:'40%',sortable:true},
                { text: 'BOTTLES', value: 'details.bottles', width:'20%',sortable:true,align:'right'},
                { text: 'CASES', value: 'details.cases', width:'20%',sortable:true,align:'right'},
                { text: 'PALLETS', value: 'details.pallets', width:'20%',sortable:true,align:'right'}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    activeHeaders() {
      return this.headers;
    },

    filteredList() {
      const searchFor = this.filters.search?.toLowerCase();
      return this.products.filter(product => {
        if (this.filters.search && !product.details.name.toLowerCase().includes(searchFor))
          return false;
        return true;
      });
    }
  },
  created() {
    this.filters.asof = this.filters.asof || this.today;
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query InventoryProducts($customerId:ID!, $asof:Date!) {
                                              version
                                              portalMessage {message,frequency}
                                              portalCustomer(customerId:$customerId) {
                                                products {
                                                  productId
                                                  details(asof:$asof) {
                                                    name
                                                    bottles
                                                    cases
                                                    pallets
                                                    lots {
                                                      lot
                                                      bottles
                                                      cases
                                                      pallets
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                            {customerId:this.$store.state.customerId, asof:this.filters.asof});
      if (!results.error) {
        this.$store.commit('setVersion', results.data.version);
        this.products = results.data.portalCustomer.products;
        this.$store.commit('setMessage', results.data.portalMessage);
      }
      this.totals();
      this.loading = false;
    },
    totals() {
      const keys = ['bottles','cases','pallets'];
      keys.forEach(key => this.listTotals[key] = 0);
      this.filteredList.forEach(product => keys.forEach(key => this.listTotals[key] += product.details[key]));
    }
  }
}
</script>